// extracted by mini-css-extract-plugin
export default {"Outer":"Switch_Outer__rLbji","Checked":"Switch_Checked__pQpG7"};